import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { RemoteControlService, REMOTE_KEY_SETS } from '../services/remote-control.service';

export const remoteControlGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): boolean => {
  const remoteControl = inject(RemoteControlService);
  const keySet = route.data['keySet'];

  if (keySet && keySet in REMOTE_KEY_SETS) {
    remoteControl.setActiveBitmask(keySet);
    return true;
  } else {
    console.error('Cannot activate route as remote control key set was not set or invalid');
    return false;
  }
};
